import { useQuery } from "@tanstack/react-query";
import { useDebounce } from "@uidotdev/usehooks";

import useApiHelper from "../hooks/useApiHelper";
import { OmniSearchResponse, OmniSearchType } from "../models/search/OmniSearch";

export default function useOmniSearch(query: string, type: OmniSearchType | null = null, enabled: boolean = true) {
  const { get } = useApiHelper();
  const debouncedQuery = useDebounce(query, 500);

  const searchType = type == null ? "" : String(type);

  const omniSearch = useQuery({
    queryKey: ["omniSearch", debouncedQuery, searchType],
    queryFn: () => get<OmniSearchResponse>(`/omnisearch?query=${encodeURIComponent(debouncedQuery)}&type=${encodeURIComponent(searchType)}`),
    enabled,
    staleTime: 1000 * 30,
  });

  return {
    omniSearch,
    debouncedQuery,
  };
}
